import React, { useRef, useState, useEffect } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { Theme } from '@mui/material/styles/createTheme';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        customWidth: {
            maxWidth: 800,
        },
        tooltipWrapper: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    })
);

const OverflowTooltip = (props: any) => {
    const { children, title, classWrapper } = props;
    const [isOverflowed, setIsOverflow] = useState(false);
    const textElementRef: any = useRef();
    const classes = useStyles();

    useEffect(() => {
        if (textElementRef && textElementRef.current) {
            setIsOverflow(textElementRef.current.scrollWidth > textElementRef.current.clientWidth ||
                textElementRef.current.scrollHeight > textElementRef.current.clientHeight);
        }
    }, [title]);

    return (
        <Tooltip
            title={title}
            disableHoverListener={!isOverflowed}
            followCursor
            placement="top"
            arrow
            classes={{ tooltip: classes.customWidth }}>
            <div
                ref={textElementRef}
                className={`${classes.tooltipWrapper} ${classWrapper}`}
            >
                {children}
            </div>
        </Tooltip>
    );
};

export default OverflowTooltip;
